module.exports = __webpack_public_path__ + "img/bg.d1e19497.webp";